import React, { useState } from "react";
import IconDeltete from "../../assets/images/icon-delete.png";
import { uploadFiles } from "api/postApi";
import { toast } from "react-toastify";
import { CONFIG_OPTION_TOAST_ERROR } from "common/toast";
import { t } from "i18next";
import { UploadOutlined } from "@ant-design/icons";
import { Button, Upload, UploadProps } from "antd";
import { Spinner } from "reactstrap";
import { getURLWithDomain } from "utils";

const props: UploadProps = {
  name: "files",
  accept: "video/mp4,video/x-m4v,video/*,image/png,image/jpeg,image/*",
  beforeUpload: () => false,
  headers: {
    authorization: "authorization-text",
  },
};

const UploadImage = ({
  data,
  setLinkImage,
  formik,
  isMultiple = true,
  uploadProps,
  isUploadMore = false,
  formikNameImage = "files",
  isListURLString = false,
  isDisabled = false,
}: any) => {
  const [isLoadingUploadImage, setIsLoadingUploadImage] =
    useState<boolean>(false);

  const formatPositionPreviewImage = (
    files: any,
    activeImage: any,
    isFormatUrl?: boolean
  ) => {
    const filesFormat = files?.filter((item: any) =>
      isListURLString === true
        ? item !== activeImage
        : item?.url !== activeImage?.url
    );

    const data = [activeImage, ...filesFormat];
    if (isFormatUrl) {
      const result = data?.map((item: any) => {
        if (isListURLString === true) return { url: getURLWithDomain(item) };

        let fileName = getURLWithDomain(item?.url);
        return {
          ...item,
          url: fileName,
        };
      });
      return result;
    }
    console.log(data);
    return data;
  };
  return (
    <React.Fragment>
      <>
        {data?.length > 0 && (
          <div
            className="overflow-x-auto color-scrollbar-os scrollbar-feed-thumbnail"
            style={{
              display: "flex",
              gap: 10,
              marginBottom: 10,
              paddingTop: 20,
            }}
          >
            {data?.map((i: any, index: number) => {
              let fileName = "";
              if (isListURLString === true) {
                fileName = getURLWithDomain(i);
              } else {
                fileName = getURLWithDomain(i?.url);

                if (i?.full_url) {
                  fileName = i?.full_url;
                }
              }

              if (i?.type == "video")
                return (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                      height: "100%",
                      cursor: "pointer",
                    }}
                  >
                    <video
                      width="160"
                      height="120"
                      controls
                      key={fileName}
                      onClick={() => {
                        setLinkImage({ url: fileName, isVideo: true });
                      }}
                    >
                      <source src={fileName} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                    {!isDisabled && (
                      <span
                        onClick={() =>
                          formik.setFieldValue(formikNameImage, [])
                        }
                        style={{
                          color: "red",
                          position: "absolute",
                          top: "-14px",
                          right: "-8px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={IconDeltete}
                          alt="delete"
                          width={18}
                          height={18}
                        />
                      </span>
                    )}
                  </div>
                );
              else
                return (
                  <div
                    key={index}
                    style={{
                      position: "relative",
                    }}
                  >
                    <img
                      alt="thumbnail"
                      src={fileName}
                      style={{
                        maxHeight: 120,
                        maxWidth: 160,
                        cursor: "pointer",
                      }}
                      onClick={() => {
                        if (
                          formik.getFieldProps(formikNameImage)?.value?.length >
                          1
                        ) {
                          const urls = formatPositionPreviewImage(
                            formik?.values?.files,
                            i,
                            true
                          );
                          // console.log(urls)
                          setLinkImage({ urls: urls });
                        } else {
                          setLinkImage({ url: fileName });
                        }
                        // setLinkImage({ url: fileName });
                      }}
                    />
                    {!isDisabled && (
                      <span
                        onClick={() => {
                          const newFilesList = [...data];
                          newFilesList.splice(index, 1);
                          formik.setFieldValue(formikNameImage, newFilesList);
                        }}
                        style={{
                          color: "red",
                          position: "absolute",
                          top: "-12px",
                          right: "-5px",
                          cursor: "pointer",
                        }}
                      >
                        <img
                          src={IconDeltete}
                          alt="delete"
                          width={18}
                          height={18}
                        />
                      </span>
                    )}
                  </div>
                );
            })}
          </div>
        )}

        <div>
          {isLoadingUploadImage && (
            <Spinner
              size="sm"
              className="me-2"
              style={{ color: "#4da3da" }}
            ></Spinner>
          )}
        </div>

        <div>
          <Upload
            {...(uploadProps ? uploadProps : props)}
            multiple={isMultiple}
            beforeUpload={() => false}
            fileList={[]}
            onChange={async (info: any) => {
              setIsLoadingUploadImage(true);
              try {
                const cloneInfo = info?.fileList?.length
                  ? [...info?.fileList]
                  : [];

                const files = info.fileList;
                const data = new FormData();
                for (var i = 0; i < files?.length; i++) {
                  data.append("files", files[i]?.originFileObj);
                }

                const res = (await uploadFiles(data)) as any;
                if (res?.code === 200) {
                  setIsLoadingUploadImage(false);
                  const fortmatedData = res?.data?.map(
                    (i: any, index: number) => {
                      if (isListURLString === true) {
                        return i?.filepath;
                      }

                      return {
                        type: cloneInfo[index]?.type.includes("video")
                          ? "video"
                          : "image",
                        url: i?.filepath,
                        view_url: i?.filepath,
                        mime: i?.mimetype,
                        width: i?.width,
                        height: i?.height,
                        caption: "Feed Image",
                        ratio: 0.9,
                      };
                    }
                  );
                  const newFiles = !isUploadMore
                    ? fortmatedData
                    : [...fortmatedData, ...formik?.values?.files];

                  formik.setFieldValue(formikNameImage, newFiles);
                  // formik.setFieldValue("files", fortmatedData);
                } else {
                  setIsLoadingUploadImage(false);
                }
              } catch (error: any) {
                setIsLoadingUploadImage(false);
                toast(
                  `${t("Input buffer contains unsupported image format")}`,
                  CONFIG_OPTION_TOAST_ERROR
                );
              }
            }}
            onRemove={() => {
              //return onGalleryFileRemove();
            }}
          >
            {/* <Button icon={<UploadOutlined />}>
                    {t("Click to Upload")}
                  </Button> */}
            {!isDisabled && (
              <Button
                disabled={isLoadingUploadImage}
                icon={
                  isLoadingUploadImage ? (
                    <Spinner size="sm" className="text-primary"></Spinner>
                  ) : (
                    <UploadOutlined />
                  )
                }
              >
                {isUploadMore && formik?.values?.files?.length > 0
                  ? t("Upload More")
                  : t("Click to Upload")}
              </Button>
            )}
          </Upload>
          {formik.touched.files && formik?.errors?.files ? (
            <div className="text-danger mt-2">{formik?.errors?.files}</div>
          ) : null}
        </div>
      </>
    </React.Fragment>
  );
};

export default UploadImage;
